import { render, staticRenderFns } from "./TellUs.vue?vue&type=template&id=c22cdd8c"
import script from "./TellUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TellUs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TellUs.vue?vue&type=style&index=0&id=c22cdd8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports